import { defineComponent as _defineComponent } from 'vue'
import { useModal } from 'vue-nice-modal'
import giftModal from './giftModal.vue'
import { PropType } from 'vue'
import type { GiftProps } from '@xt/client/utils/messageModalQueue/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  dataSource: {
    required: true,
    type: Object as PropType<GiftProps>
  }
},
  setup(__props) {

const props = __props;

const modal = useModal() // hook 在 wrapper 中使用


// 关闭
const onClose = () => {
  modal.resolve({
    status: 'cancel'
  })
  modal.hide()
}

return { __sfc: true,modal, props, onClose, giftModal }
}

})